import { getAssetUrl } from 'lib/config/assetUrls';

const scene = (file: string) =>
  getAssetUrl(`/web_v2/site-static/spline/${file}`);

export const powerplugsDesktopSrc = scene('powerplugs-desktop.splinecode');
export const powerplugsMobileSrc = scene('powerplugs-resp.splinecode');
export const bloodVisionDesktopSrc = scene('scene-bv.splinecode');
export const bloodVisionMobileSrc = scene('scene-bv-responsive.splinecode');
export const sizingKitDesktopSrc = scene('dark-rings-desktop.splinecode');
export const sizingKitMobileSrc = scene('dark-rings-responsive.splinecode');
